import React from "react";
import {Tag} from "primereact/tag";
import {templateRuleSummary} from "../../utils/pricingTemplate";
import {protectionStrategies} from "../../utils/Constants";

// Presentational, read-only view of a repricing rule's properties: the
// direction/value headline, the reduction type, and the protection / update /
// no-competitor chips. Shared by RuleCard (list) and ApplyTemplateDialog (apply
// preview) so a rule renders identically in both places. When showHeader is set,
// a name + status badge header is rendered too (read-only — no toggle here).
const RuleDetails = ({rule, t, showHeader = false}) => {
    if (!rule) return null;

    const active = !!rule.is_active;
    const direction = rule.reduction_direction === -1 ? 'pi-arrow-up-right' : 'pi-arrow-down-right';
    const typeLabel = rule.reduction_type === 'ratio' ? t('reprice.ratio') : t('reprice.amount');
    const protLabel = (protectionStrategies(t).find(p => p.value === (rule.protection_strategy || 'min_value')) || {}).label;

    const chip = (icon, text) => (
        <span style={{fontSize: 12, background: '#f3f4f6', color: '#374151',
            padding: '3px 8px', borderRadius: 6, display: 'inline-flex', alignItems: 'center', gap: 4}}>
            <i className={icon} style={{fontSize: 13}}/> {text}
        </span>
    );

    return (
        <div style={{display: 'flex', flexDirection: 'column', gap: 12}}>
            {showHeader &&
                <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8}}>
                    <span style={{fontWeight: 700}}>{rule.name}</span>
                    <Tag value={active ? t('actions.active') : t('actions.passive')}
                         severity={active ? 'success' : null}
                         style={active ? undefined : {background: '#e5e7eb', color: '#6b7280'}}/>
                </div>}

            <div style={{display: 'flex', alignItems: 'center', gap: 10}}>
                <span style={{width: 34, height: 34, borderRadius: '50%', background: '#f3f4f6',
                    display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#6b7280'}}>
                    <i className={'pi ' + direction}/>
                </span>
                <div>
                    <div style={{fontSize: 16, fontWeight: 600}}>{templateRuleSummary(rule, t)}</div>
                    <div style={{fontSize: 12, color: '#9ca3af'}}>{typeLabel}</div>
                </div>
            </div>

            <div style={{display: 'flex', flexWrap: 'wrap', gap: 6}}>
                {chip('pi pi-shield', protLabel)}
                {chip(rule.is_auto_update ? 'pi pi-bolt' : 'pi pi-hand', rule.is_auto_update
                    ? t('reprice.auto_update') : t('reprice.manuel_update'))}
                {rule.no_competitor_strategy && chip('pi pi-user-minus', t('reprice.no_competitor_strategy'))}
            </div>
        </div>
    );
};

export default RuleDetails;
